<template> 
 <div v-if="confirmDialog.visible" class="confirm-dialog">
      <div class="confirm-dialog-content">
        <h3>Conferma la visibiltà</h3>
        <p>Sei sicuro di voler procedere?</p>
        <Button @click="confirmDialogAccept" label="Procedi" />
        <Button @click="confirmDialogReject" label="Annulla" class="p-button-secondary" />
      </div>
    </div>

    <div v-if="confirmDialogTrash.visible" class="confirm-dialog">
      <div class="confirm-dialog-content">
        <h3>Modifica</h3>
        
            <!-- Primo textarea -->
        <Textarea v-model="confirmDialogTrash.title" placeholder="Inserisci il titolo" rows="10" style="width: 100%;"></Textarea>

        <br/>
        <!-- Secondo textarea -->
        <Textarea v-model="confirmDialogTrash.description" placeholder="Inserisci la descrizione" rows="10" style="width: 100%;"></Textarea>
        <br/>
        <Textarea v-model="confirmDialogTrash.url" placeholder="Inserisci l'indirizzo del pdf" rows="2" style="width: 100%;"></Textarea>

        <br/><br/>
        <!-- Sezione per immagine -->
        <div class="image-preview">
          <img v-if="imagePreview" :src="getImageUrl(confirmDialogTrash.imagePreview)" alt="Preview" class="preview-img" />
          <p v-else>Nessuna immagine selezionata</p>
        </div>

        <!-- Bottone per cambiare immagine -->
        <input type="file" @change="onImageChange" accept="image/*" />

<br/><br/>
        <p>Sei sicuro di voler procedere?</p>
        <Button @click="confirmDialogTrashAccept" label="Procedi" />
        <Button @click="confirmDialogTrashReject" label="Annulla" class="p-button-secondary" />
      </div>
    </div>
  <Loader v-if="loading" />    
  <Card>
    <template v-slot:title>
      <h3>Configurazione pagine INTRODUTTIVE in APP</h3>
    </template>
    <template v-slot:content>
     
      
      <div class="col-12 flex flex-column md:col-12">
        <table>
              <thead>
                <tr>
                  <th>Titolo</th>
                  <th>Descrizione</th>
                  <th style="width: 200px;">Immagine</th>
                  <th style="width: 100px;">URL</th>
                  <th style="width: 100px;">TAG</th>
                  <th style="width: 50px;"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="n in newsInApp" :key="n.id">
                  <td>{{ n.title }}</td>
                  <td>{{ n.description }}</td>
                
                  <td style="text-align: center;">
                    <img v-if="n.img" :src="getImageUrl(n.img)" alt="Image" style="max-width: 200px; max-height: 200px;" />
                  </td>
                 
                  <td>{{ n.url }}</td>
                
                  <td>{{ n.tag }}</td>
                  <td><Button @click="openConfirmDialogTrash(n.id,n.visibile,n.title,n.description,n.img)" class='p-button-warning'><i class='pi pi-pencil'></i></Button></td>
                </tr>
              </tbody>
            </table>
       
        </div>
    </template>
  </Card>
</template>

<script>
import {ref, onMounted, getCurrentInstance } from 'vue';
import Loader from "@/components/Loader.vue"
import Service from '@/services/levante-api/levante-api'
import moment from 'moment'
import { useToast } from 'primevue/usetoast';

export default {
  components: {
    Loader,
  },
  
  setup () { 
    const self = getCurrentInstance();
    const toast = useToast();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    const service = new Service(self.$eventBus)
    const submitted = ref(false)
    const loading = ref(false)
    const newsInApp = ref([]);

    const validationErrors = ref({})
    const types = ref()
    const date = moment();
    const buttonDays = ref([])
    const boxes = ref([])
    const lifeTime = 3000;
    const confirmDialog = ref({
      visible: false,
      id: null,
      visibile: null
    });
    const confirmDialogTrash = ref({
      visible: false,
      id: null,
      visibile: null,
      title:null,
      description:null,
      imagePreview:null
    });

    const getImageUrl = (imgPath) => {
      return `${process.env.VUE_APP_LEVANTE_API_URL}/../storage/app/public/${imgPath}`;
    }
    const validateForm = (box) => {
      if (box.description.length==0){
        toast.add({ severity: 'error', summary: 'Inserisci una descrizione', detail: 'Inserisci una descrizione', life: 3000 });
        return false;
      }
      if (box.title.length==0){
        toast.add({ severity: 'error', summary: 'Inserisci un titolo', detail: 'Inserisci un titolo', life: 3000 });
        return false;
      }
      if (!box.image){
        toast.add({ severity: 'error', summary: 'Inserisci un titolo', detail: 'Immagine non presente', life: 3000 });
        return false;
      }
      return true;
    }

    const onImageChange = (event) => {
      const file = event.target.files[0];
      confirmDialogTrash.value.imagePreview = file;
    }
    const openConfirmDialogTrash= (id, visibile,title,description,img) => {
      confirmDialogTrash.value.visible = true;
      confirmDialogTrash.value.id = id;
      confirmDialogTrash.value.visibile = visibile;
      confirmDialogTrash.value.title=title;
      confirmDialogTrash.value.description=description;
      confirmDialogTrash.value.imagePreview=img;
    };

    
    const confirmDialogTrashAccept = () => {
      updateValue(confirmDialogTrash.value.id);
      confirmDialogTrash.value.visible = false;
    };

    const confirmDialogTrashReject = () => {
      toast.add({ severity: 'error', summary: 'Annullato', detail: 'Operazione annullata', life: 3000 });
      confirmDialogTrash.value.visible = false;
    };
  



    const updateValue = async (id) => {
      loading.value = true;

      try {
        let fd = new FormData();  
        fd.append("description",confirmDialogTrash.value.description);
        fd.append("image",confirmDialogTrash.value.imagePreview);
        fd.append("title",confirmDialogTrash.value.title);
        fd.append("url",confirmDialogTrash.value.url);
        fd.append("id",confirmDialogTrash.value.id);
        await service.updateValueIntro(id,fd);  // assuming this endpoint exists
        toast.add({ severity: 'success', summary: 'Successo', detail: 'Cancellazione effettuata con successo',life: lifeTime});
        initData();
      } catch (error) {
        toast.add({ severity: 'error', summary: 'Errore', detail: 'Errore',life: lifeTime });
      } finally {
        loading.value = false;
      }
    };
 
    
    const initData = () => {
      // restart var

      service.getIntro().then((res) => {
         newsInApp.value = res.items
      });
    }
 
    

    
    onMounted(() => { 
      loading.value = true
      const promises = [initData()]
      
      Promise.all(promises)
      .then(()=>{
          
      }).finally(()=>{
          loading.value = false
      })
    })
    
    return {
      loading,
      submitted,
      validationErrors,
      types,
      moment,
      newsInApp,
      date,
      buttonDays,
      boxes,
      confirmDialog,
      confirmDialogTrash,
      onImageChange,
      openConfirmDialogTrash,
      confirmDialogTrashReject,
      confirmDialogTrashAccept,
      getImageUrl
    }
  },
}
</script>

<style>
.text_toupper{
  text-transform: uppercase;
} 
</style>
<style scoped>
.counter{
  position:absolute;
  right:10px;
  top:10px;
}
#container-atleti{
  display: block;
}
.layout-main-container{
  width: fit-content !important;
}
.btn-error-filter{
  width: 200px;
}

.btn-campo{
  background:#ffffff url("/images/campo.jpg") no-repeat right top;
  background-size: contain;
  width: 100px;
  aspect-ratio:1 ;
}

.numero-campo{
  color: black;
  font-size: 40px;
  font-weight: 500;
  position: relative;
  z-index: 2;
}
table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  border: 1px solid #ddd;
  padding: 8px;
}

th {
  background-color: #f2f2f2;
}

.confirm-dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.2);
  z-index: 1000;
  width:500px;
}

.confirm-dialog-content {
  text-align: center;
}

.confirm-dialog-content h3 {
  margin-top: 0;
}

.confirm-dialog-content button {
  margin: 10px;
}
</style>
